import React from "react"

interface StatusIndicatorProps {
   label: string
   condition?: boolean
}

export default function StatusIndicator({label, condition}: StatusIndicatorProps) {
   const colorClass =
      condition === undefined
         ? "bg-gray-100 border-gray-300 text-gray-500"
         : condition
           ? "bg-green border-green text-green"
           : "bg-red border-red text-red"

   return (
      <div
         className={`rounded border px-4 py-1 text-center bg-opacity-20 ${colorClass}`}
      >
         {label}
      </div>
   )
}
